import { render } from "./MyPayoutsView.vue?vue&type=template&id=53c44b37&scoped=true"
import script from "./MyPayoutsView.vue?vue&type=script&lang=js"
export * from "./MyPayoutsView.vue?vue&type=script&lang=js"

import "./MyPayoutsView.vue?vue&type=style&index=0&id=53c44b37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c44b37"]])

export default __exports__